// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"c020a283","581":"d9c3c8db","714":"a784c437","821":"f08fd8b4"}[chunkId] + ".chunk.js";
};